import { render } from "./SidebarMenuItemCatalog.vue?vue&type=template&id=6a418fa2&scoped=true"
import script from "./SidebarMenuItemCatalog.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItemCatalog.vue?vue&type=script&lang=js"

import "./SidebarMenuItemCatalog.vue?vue&type=style&index=0&id=6a418fa2&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a418fa2"]])

export default __exports__